import axios from "axios";

export const BACKEND = process.env.REACT_APP_BACKEND_URL;
export const api = axios.create({ baseURL: `${BACKEND}/api`, withCredentials: true });

let refreshing = null;
api.interceptors.response.use(
  (r) => r,
  async (err) => {
    const cfg = err.config || {};
    const url = cfg.url || "";
    const skip = ["/auth/refresh", "/auth/login", "/auth/register", "/auth/session"].some((p) => url.includes(p));
    if (err.response?.status === 401 && !cfg._retry && !skip) {
      cfg._retry = true;
      try {
        refreshing = refreshing || api.post("/auth/refresh");
        await refreshing;
        refreshing = null;
        return api(cfg);
      } catch (e) {
        refreshing = null;
      }
    }
    return Promise.reject(err);
  }
);

export function errMsg(e, fallback = "Une erreur est survenue. Veuillez réessayer.") {
  const detail = e?.response?.data?.detail;
  if (detail == null) return fallback;
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((x) => x?.msg || JSON.stringify(x)).join(" ");
  return detail.msg || String(detail);
}

export const fileUrl = (u) => (u && u.startsWith("/api") ? `${BACKEND}${u}` : u);

export const POPULAR = [
  "Dépanneur machine à laver", "Plombier", "Électricien", "Serrurier", "Menuisier", "Boulangerie",
  "Garage automobile", "Réparation téléphone", "Paysagiste", "Chauffagiste", "Couvreur", "Peintre",
  "Constructeur de maisons", "Constructeur de bateaux", "Constructeur automobile", "Fabricant de meubles",
  "Fabricant de cuisines", "Chantier naval", "Ébéniste", "Chocolatier", "Vigneron", "Imprimerie",
];
